export * from './auth'
export * from './network'
export * from './region'
export * from './productLine'
export * from './label'
export * from './empty'
export * from './image'

export const BASE_NAME = '/task'
